import React, { useEffect, useRef } from 'react'
import { finalRank, shorten } from '../../utils/filters'
import Flag from '../common/Flag'

export default function QualiTable({ results, current }) {
  const highlightedRowRef = useRef(null)
  const scrolledBibsRef = useRef(new Set())
  
  const isHighlighted = (row) => {
    return current && String(current.bib) === String(row.bib)
  }
  
  useEffect(() => {
    if (highlightedRowRef.current && current) {
      const bib = String(current.bib)
      if (!scrolledBibsRef.current.has(bib)) {
        scrolledBibsRef.current.add(bib)
        highlightedRowRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }, [current])

  if (!results || results.length === 0) {
    return <p>No results available</p>
  }

  return (
    <table className="resultstable" cellSpacing="0" cellPadding="0" width="100%">
      <thead>
        <tr>
          <th className="text-center">Rank</th>
          <th className="text-center hidden md:table-cell">Bib</th>
          <th className="text-center">Q</th>
          <th>Name</th>
          <th>Nat.</th>
          <th className="text-center">Distance</th>
          <th className="text-center hidden md:table-cell">Points</th>
        </tr>
      </thead>
      <tbody>
        {results.map((row, index) => (
          <tr 
            key={index}
            ref={isHighlighted(row) ? highlightedRowRef : null}
            className={`${index % 2 === 0 ? 'even' : 'odd'} ${isHighlighted(row) ? 'highlight' : ''}`}
          >
            <td className="text-center">{finalRank(row)}</td>
            <td className="text-center hidden md:table-cell">{row.bib}</td>
            <td 
              className={`text-center ${
                row.qualified === 'NQ' ? 'red' : row.qualified === 'Q' ? 'green' : ''
              }`}
            >
              {row.qualified}
            </td>
            <td>
              <span className="hidden md:inline">{row.name}</span>
              <span className="md:hidden">{shorten(row.name)}</span>
            </td>
            <td>
              <Flag code={row.nation} />
            </td>
            <td className="text-center">
              {row.length1 ? row.length1.toFixed(1) : '-'}
            </td>
            <td className="text-center hidden md:table-cell">
              {row.points1 ? row.points1.toFixed(1) : '-'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
